import { Component, OnInit, input, output } from '@angular/core';
import { uploadedIconsAreTheExpected } from '../../helpers/validators.helper';
import { WhitelabelAndroidFullIconsName } from '../../models/whitelabel-android-config';

@Component({
  standalone: false,
  selector: 'app-whitelabel-android-icons-upload',
  templateUrl: './whitelabel-android-icons-upload.component.html',
  styleUrls: ['./whitelabel-android-icons-upload.component.css']
})
export class WhitelabelAndroidIconsUploadComponent implements OnInit {

  readonly type = input.required<'icons' | 'appIcon'>();

  public readonly errorEvent$ = output<void>();

  public readonly successEvent$ = output<File[] | File>();

  ngOnInit(): void {
  }

  public onIconsUpload(event: any) {
    const files = event.target.files as FileList;
    const uploadedFiles = Array.from(files);

    if (!uploadedIconsAreTheExpected(uploadedFiles, WhitelabelAndroidFullIconsName)) {
      this.errorEvent$.emit();
      return;
    }

    this.successEvent$.emit(uploadedFiles);
    return;
  }

  public onAppIconUpload(event: any) {
    const files = event.target.files as FileList;
    const uploadedFile = files[0];
    
    if (uploadedFile) {
      const isValid = uploadedFile.name === 'logo.png';

      if (!isValid) {
        this.errorEvent$.emit();
        return;
      }

      this.successEvent$.emit(uploadedFile);
    }

    return;
  }

}
